export default "__VITE_ASSET__dpRtGTkB__"